import axios, { AxiosResponse } from 'axios';

import { MemberT } from '../types/types';

import { SESSION_TOKEN } from '../constants';

interface GetMemberResponse {
  member: MemberT;
  zendesk: { userId: number; id: number; title: string; body: string }[];
}

export function memberService(apiDomain: string) {
  const smilesMemberUrl = `${apiDomain}/members/v1/members`;
  const token = localStorage.getItem(SESSION_TOKEN);
  const get = () => {
    return axios
      .get(smilesMemberUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response: AxiosResponse<GetMemberResponse>) => {
        return response.data;
      })
      .catch((error) => error);
  };

  return {
    get,
  };
}
